import React from 'react';
import PropTypes from 'prop-types';
import HoverTooltip from '@Components/HoverTooltip';
import { Button } from '@els/els-react--button';
import { TooltipConstants } from '@Components/Tooltip';
import ReactDOMServer from 'react-dom/server';
import { copySmiles, getCustomerIconAriaLabel, getCustomerIconMapping, trackCustomerIconClick } from './structure-utils';
import StructureToolbarCustomerIconTooltip from './StructureToolbarCustomerIconTooltip';
import CustomerLibraryBadge from './CustomerLibraryBadge';

import './StructureToolbarCustomerIcon.scss';

export default function StructureToolbarCustomerIcon({ structure, customerInfo = {} }) {
  const customerIconMapping = getCustomerIconMapping(customerInfo);

  if (!customerIconMapping) return null;

  const { badge, icon, label, tooltipLabel } = customerIconMapping;
  const onClick = () => {
    trackCustomerIconClick(label);
    return copySmiles(structure);
  };
  const tooltip = ReactDOMServer.renderToString(<StructureToolbarCustomerIconTooltip customerLabel={tooltipLabel} />);
  const ariaLabel = getCustomerIconAriaLabel(tooltipLabel) || '';
  return (
    <HoverTooltip id={TooltipConstants.ids.GlobalHover} tooltip={tooltip} theme="simple" tooltipPlace="top">
      <Button
        data-e2e="structure-toolbar-customer-icon-button"
        type="borderless"
        size="small"
        onClick={onClick}
        className={`structure-customer-icon e2e-structure-customer-icon ${icon}${badge ? ' structure-customer-icon--with-badge' : ''}`}
        aria-label={ariaLabel}>
        <svg className="els-btn-icon rx-border-none structure-customer-icon__logo">
          <use xlinkHref={`#icon-${icon}`} />
        </svg>
        {badge && (
          <span className="structure-customer-icon__badge">
            <CustomerLibraryBadge content={badge.content} />
          </span>
        )}
      </Button>
    </HoverTooltip>
  );
}

StructureToolbarCustomerIcon.propTypes = {
  structure: PropTypes.string,
  customerInfo: PropTypes.object,
};
